import { render, staticRenderFns } from "./CardScrub.vue?vue&type=template&id=46426605&"
import script from "./CardScrub.vue?vue&type=script&lang=js&"
export * from "./CardScrub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports